import { memo } from "react";
import { Box } from "@mui/material";
import {
  Contenedor,
  Documentos,
  PackSellos,
  SellosArriboVerificadora,
  Siglas,
  Transporte,
} from "./components";
import { SellosArriboExporbananas } from "./components/libs/sellos-arribo-exporbananas";
import type { CollapseProps } from "antd";
import { Collapse, ConfigProvider } from "antd";

interface ThirdComponentPropsI {
  widthFull: string;
  activeKey: any;
  setActiveKey: (key: any) => void;
}
export const ThirdComponent = memo(
  ({ widthFull, activeKey, setActiveKey }: ThirdComponentPropsI) => {


    const items: CollapseProps["items"] = [
      {
        key: "1",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SIGLAS
          </p>
        ),
        children: <Siglas />,
      },
      {
        key: "2",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            DOCUMENTOS
          </p>
        ),
        children: <Documentos />,
      },
      {
        key: "3",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            TRANSPORTE
          </p>
        ),
        children: <Transporte widthFull={widthFull} />,
      },
      {
        key: "4",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SELLOS ARRIBO VERIFICADORA
          </p>
        ),
        children: <SellosArriboVerificadora widthFull={widthFull}/>,
      },
      {
        key: "5",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SELLOS ARRIBO EXPORTADOR
          </p>
        ),
        children: <SellosArriboExporbananas widthFull={widthFull} />,
      },
      {
        key: "6",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            ESTRUCTURA DEL CONTENEDOR
          </p>
        ),
        children: <Contenedor />,
      },
      {
        key: "7",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            PACK SELLOS
          </p>
        ),
        children: <PackSellos widthFull={widthFull}/>,
      },
    ];

    return (
      <Box
        sx={{
          minHeight: `calc(100vh - 120px)`,
          maxHeight: `calc(100vh - 120px)`,
          height: `calc(100vh - 120px)`,
          overflowY: "auto",
          m: 0,
          overflowX: "hidden",
          position: "relative",
          pt: 5,
          minWidth: "100%",
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Collapse: {
                contentPadding: "0px",
              },
            },
            token: {
              motionDurationSlow: "0.2s",
            },
          }}
        >
          <Collapse
            style={{
              width: "100%",
              minWidth: "100%",
            }}
            accordion={true}
            expandIconPosition="end"
            items={items}
            bordered={false}
            destroyInactivePanel={true}
            activeKey={activeKey}
            onChange={(key: string[] | string) => {
              setActiveKey!(key as string[]);
            }}
          />
        </ConfigProvider>
      </Box>
    );
  }
);
